export enum BannerType {
  EVENTS = 'events',
  FLIGHTS = 'flights',
}
